var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 10.743 10.743",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Download",
    transform: "translate(-300.155 -192.426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "download_FILL1_wght400_GRAD0_opsz48",
    d: "M9.007,18.743A1.033,1.033,0,0,1,8,17.736v-2.4H9.007v2.4h8.728v-2.4h1.007v2.4a1.033,1.033,0,0,1-1.007,1.007Zm4.364-2.568-3.24-3.24.722-.722,2.014,2.014V8h1.007v6.227l2.014-2.014.722.722Z",
    transform: "translate(292.155 184.426)",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.d4a6568b4015c4ab2db5b6cfa78ef9fa.svg";
export { ForwardRef as ReactComponent };